import { IMediaDeviceStartupException } from '../interfaces/IMediaDeviceStartupException';

export default class MediaDeviceStartupException implements IMediaDeviceStartupException 
{
  caption: string;
  endDate: string;
  id: string;
  startDate: string;
}
